import type { SVGProps } from "react";

export function IconPlayTriangle({
  width = 24,
  height = 28,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      height={height}
      viewBox="0 0 60 60"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: verbatim Webflow SVG icon — gradient/clipPath content cannot be expressed in JSX
      dangerouslySetInnerHTML={{
        __html: `
<path d="M25.16 40.9607L40.18 31.3607C40.72 31.0207 41 30.5407 41 29.9407C41 29.3407 40.72 28.8807 40.18 28.5207L25.16 18.9207C24.62 18.5207 24.04 18.4807 23.44 18.8007C22.84 19.1207 22.54 19.6407 22.54 20.3207V39.5207C22.54 40.2207 22.84 40.7207 23.44 41.0407C24.04 41.3607 24.6 41.3207 25.16 40.9207V40.9607ZM29.76 59.7207C25.7 59.7207 21.84 58.9407 18.22 57.3807C14.6 55.8207 11.44 53.6807 8.74 50.9807C6.04 48.2807 3.9 45.1207 2.34 41.5007C0.78 37.8807 0 34.0407 0 29.9607C0 25.8807 0.78 21.9807 2.34 18.3607C3.9 14.7407 6.04 11.6007 8.74 8.9207C11.44 6.2407 14.6 4.1207 18.22 2.5607C21.84 1.0007 25.68 0.220703 29.76 0.220703C33.84 0.220703 37.74 1.0007 41.36 2.5607C44.98 4.1207 48.12 6.2407 50.8 8.9207C53.48 11.6007 55.6 14.7407 57.16 18.3607C58.72 21.9807 59.5 25.8407 59.5 29.9607C59.5 34.0807 58.72 37.8807 57.16 41.5007C55.6 45.1207 53.48 48.2807 50.8 50.9807C48.12 53.6807 44.98 55.8207 41.36 57.3807C37.74 58.9407 33.88 59.7207 29.76 59.7207Z" fill="white"/>
`,
      }}
    />
  );
}
